export default __webpack_public_path__ + "static/media/sentiment_dissatisfied.ea80d173.svg";